import { C as CosmosIconChevronLeft$1, d as defineCustomElement$1 } from './p-BFQO8TB_.js';

const CosmosIconChevronLeft = CosmosIconChevronLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronLeft, defineCustomElement };
